<template>
  <div class="p-2 bg-light border-bottom d-flex">
    <b-btn size="sm" variant="secondary" :disabled="progressing" @click="emitCreateFolder">
      <font-awesome-layers class="align-middle" fixed-width>
        <font-awesome-icon icon="folder" size="lg" class="text-white"></font-awesome-icon>
        <font-awesome-icon icon="plus" transform="shrink-7 down-1 left-1"></font-awesome-icon>
      </font-awesome-layers>
      <span class="ml-2"></span>
      {{$t('fileManager.createFolder')}}
    </b-btn>
    <b-btn size="sm" variant="secondary" class="mx-2" :disabled="progressing" @click="emitUpload">
      <font-awesome-layers class="align-middle" fixed-width>
        <font-awesome-icon icon="cloud" size="lg" class="text-white"></font-awesome-icon>
        <font-awesome-icon icon="arrow-up" transform="shrink-3 down-1 left-4"></font-awesome-icon>
      </font-awesome-layers>
      <span class="ml-2"></span>
      {{$t('fileManager.upload')}}
    </b-btn>

    <div class="mr-auto">
      <b-btn size="sm" variant="link" :disabled="progressing" @click="emitRefresh">
      <font-awesome-icon icon="sync" :spin="progressing" size="lg" class="text-secondary"></font-awesome-icon>
    </b-btn>
    </div>
  </div>
</template>

<script>
import { FontAwesomeLayers } from '@fortawesome/vue-fontawesome'

export default {
  name: 'f-toolbar',
  components: {
    FontAwesomeLayers
  },
  props: {
    progressing: {type: Boolean, required: true}
  },
  methods: {
    emitRefresh () {
      this.$emit('refresh')
    },
    emitCreateFolder () {
      this.$emit('openCreateFolder')
    },
    emitUpload () {
      this.$emit('openUploader')
    }
  }
}
</script>
